import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  ["Explore", [["Concepts", "/concepts"], ["Case Studies", "/case-studies"], ["Journal", "/blogs"]]],
  ["Engage", [["Request a Concept", "/request-concept"], ["Start a Project", "/#enquiry"], ["Services", "/#services"]]],
];

export const Footer = () => {
  const navigate = useNavigate();
  const go = (href) => {
    if (href.startsWith("/#")) navigate("/", { state: { scrollTo: href.slice(2) } });
    else navigate(href);
  };
  return (
    <footer className="bg-[#1A1713] text-[#FDFBF7] py-16" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-12 border-b border-white/10 pb-12">
          <div>
            <button onClick={() => navigate("/")} className="flex items-center gap-4">
              <Logo size={52} />
              <div className="text-left">
                <p className="font-serif text-2xl tracking-[0.15em] text-[#FDFBF7]">AURELUME</p>
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#FDFBF7]/50">Branding Solutions LLP</p>
              </div>
            </button>
            <p className="font-serif italic text-2xl md:text-3xl text-[#FDFBF7]/80 max-w-md mt-8">
              Category leaders aren&rsquo;t discovered. They&rsquo;re built.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8">
            {COLS.map(([title, links]) => (
              <div key={title}>
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059] mb-4">{title}</p>
                <ul className="space-y-3">
                  {links.map(([label, href]) => (
                    <li key={label}>
                      <button
                        onClick={() => go(href)}
                        data-testid={`footer-${label.toLowerCase().replace(/\s/g, "-")}`}
                        className="text-sm text-[#FDFBF7]/70 hover:text-[#FDFBF7] link-underline"
                      >
                        {label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-4 pt-8 text-xs text-[#FDFBF7]/50 uppercase tracking-[0.15em]">
          <p>© {new Date().getFullYear()} Aurelume Branding Solutions LLP · MSME Certified</p>
          <div className="flex gap-6">
            <a href="tel:+918796953955" className="hover:text-[#FDFBF7]">+91 87969 53955</a>
            <a href="mailto:aurelumebranding@gmail.com" className="hover:text-[#FDFBF7] normal-case tracking-normal">aurelumebranding@gmail.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
